export default "__VITE_ASSET__hNtbtzSc__"